var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.66 6.52575L6.70997 2.57575C6.52782 2.38715 6.42702 2.13455 6.4293 1.87235C6.43158 1.61016 6.53675 1.35934 6.72216 1.17394C6.90756 0.988528 7.15838 0.883359 7.42057 0.88108C7.68277 0.878802 7.93537 0.979596 8.12397 1.16175L13.781 6.81875C13.8742 6.91141 13.9481 7.02157 13.9986 7.1429C14.049 7.26423 14.075 7.39435 14.075 7.52575C14.075 7.65716 14.049 7.78727 13.9986 7.90861C13.9481 8.02994 13.8742 8.1401 13.781 8.23275L8.12397 13.8898C8.03173 13.9853 7.92138 14.0614 7.79938 14.1139C7.67737 14.1663 7.54615 14.1939 7.41338 14.195C7.2806 14.1962 7.14892 14.1709 7.02602 14.1206C6.90312 14.0703 6.79147 13.996 6.69758 13.9021C6.60369 13.8083 6.52943 13.6966 6.47915 13.5737C6.42887 13.4508 6.40357 13.3191 6.40472 13.1864C6.40588 13.0536 6.43346 12.9224 6.48587 12.8004C6.53828 12.6783 6.61446 12.568 6.70997 12.4758L10.66 8.52575H1.07397C0.808758 8.52575 0.554404 8.4204 0.366868 8.23286C0.179331 8.04532 0.0739746 7.79097 0.0739746 7.52575C0.0739746 7.26054 0.179331 7.00618 0.366868 6.81865C0.554404 6.63111 0.808758 6.52575 1.07397 6.52575H10.66Z",
    fill: "#E4B104"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.634e2e16dadabb10ccae1f01656176a4.svg";
export { ForwardRef as ReactComponent };